module.exports = __webpack_public_path__ + "img/quyun-app-download-qrcode.bb9aa9c6.png";